module.exports = __webpack_public_path__ + "static/media/promo.f0fb25c3.png";